export default "__VITE_ASSET__gPhsjB_o__"